function generatePreviewImgs(data) {
  const preUrl = data.urlList && data.urlList.length > 0 ? data.urlList[0] : '';
  const transferMeta = data.transferMeta;
  if (preUrl && transferMeta && transferMeta.data) {
    const imgs = [];
    for (let i = 0; i < transferMeta.data.totalPages; i++) {
      const imgUrl = `${preUrl}${transferMeta.data.staticSuffix}_${i}.${transferMeta.data.ext}`;
      imgs.push(imgUrl);
    }
    return imgs;
  }
  return [];
}

function generatePreviewVideo(url) {
  let sourceUrl = url;
  if (sourceUrl) {
    // 如果不是.mpd结尾，需要去掉所有可能的视频格式后缀
    if (sourceUrl.indexOf('.mpd') === -1) {
      sourceUrl = sourceUrl.substring(0, sourceUrl.lastIndexOf('/'));
      sourceUrl += '/next/playlist.mpd';
    }
    let desDomain = 'lc.v5live.com';
    if (process.env.BUILD_ENV === 'dev') {
      desDomain = 'lc.dev.v5live.com/ahhcvyf6pmv';
    } else if (process.env.BUILD_ENV === 'test') {
      desDomain = 'lc.test.v5live.com/ahhcvyf6pmv';
    }
    //  直播规则
    const desURL = `https://${desDomain}/?source=${encodeURIComponent(sourceUrl)}#/embed-player`;
    return desURL;
  }
  return '';
}

export { generatePreviewImgs, generatePreviewVideo };
